export const isMobile = () => {
  const ua = navigator.userAgent
  const regexp = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/
  return regexp.test(ua) && !isTablet()
}

export const isTablet = () => {
  const ua = navigator.userAgent
  const regexp = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i
  return regexp.test(ua)
}

export const isDesktop = () => {
  return !isMobile() && !isTablet()
}

export const isIE = () => {
  return window.navigator.userAgent.toLowerCase().includes('msie')
}

export const hexColorToDec = (color: string) => {
  const rExp = /[^a-z0-9]/gi
  const hex = color.replace(rExp, '')

  return parseInt(hex, 16)
}

export const omitNonDigitPipe = (raw: string) => {
  return raw.replace(/\D+/g, '')
}
